import React, { useState } from 'react';
import { Button, Input, Message, Card, Space, Typography } from '@arco-design/web-react';
import { IconLock } from '@arco-design/web-react/icon';
import './styles.scss';

const { Title, Text } = Typography;

interface PasswordProtectionProps {
    onSuccess: () => void;
}

export const PasswordProtection: React.FC<PasswordProtectionProps> = ({ onSuccess }) => {
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        validatePassword();
    };

    const validatePassword = () => {
        setLoading(true);

        // Simulate a brief loading delay
        setTimeout(() => {
            if (password === 'MySecret0Password123') {
                Message.success('Access granted!');
                onSuccess();
            } else {
                Message.error('Incorrect password. Please try again.');
                setPassword('');
            }
            setLoading(false);
        }, 500);
    };

    return (
        <div className="password-protection-container">
            <Card className="password-protection-card">
                <div className="password-protection-content">
                    <Space direction="vertical" size="large" style={{ width: '100%' }}>
                        <div className="password-protection-header">
                            <div className="lock-icon">
                                <IconLock style={{ fontSize: 28, color: '#000000' }} />
                            </div>
                            <Title heading={3}>
                                Secure Access
                            </Title>
                            <Text type="secondary">
                                Enter password to access the template editor
                            </Text>
                        </div>

                        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                            <Space direction="vertical" size="medium" style={{ width: '100%' }}>                                <Input.Password
                                placeholder="Enter your password"
                                value={password}
                                onChange={setPassword}
                                size="large"
                                autoFocus
                                onPressEnter={handleSubmit}
                            />                                  <Button
                                type="primary"
                                size="large"
                                loading={loading}
                                onClick={validatePassword}
                                style={{ width: '100%' }}
                                disabled={!password.trim()}
                            >
                                    Continue to Editor
                                </Button>
                            </Space>
                        </form>
                    </Space>
                </div>
            </Card>
        </div>
    );
};
